console.log('components');

import './components/quiz';
import './components/accordeon';
import './components/map';
import './components/products';
import './components/cart';
import './components/range-slider';
import './components/burger';
